import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import chikooPulpData from "./chikoo-pulp-data";
import ProductVariations from "../../components/ProductVariations/ProductVariations";
import OverlayCard from "../../components/OverlayCard/OverlayCard";
import FeatureCard from "../../components/FeatureCard/FeatureCard";
import FeatureTextSection from "../../components/FeatureTextSection/FeatureTextSection";

const ChikooPulpPage = () => {
  const [products, setProducts] = useState([]);
  const [mainProduct, setMainProduct] = useState({});
  const [heroSection, setHeroSection] = useState({});
  const [featureCardsInfo, setFeatureCardsInfo] = useState([]);
  const [textSection, setTextSection] = useState({});
  const [feature_text_section, setFeatureTextSection] = useState({});
  const [OverlayCards, setOverlayCards] = useState([]);
  const [why_choose_section, setWhyChooseSection] = useState({});
  
  useEffect(() => {
    setProducts(chikooPulpData.products);
    setMainProduct(chikooPulpData.main_product);
    setHeroSection(chikooPulpData.hero_section);
    setTextSection(chikooPulpData.text_section);
    setFeatureTextSection(chikooPulpData.feature_text_section);
    setFeatureCardsInfo(chikooPulpData.feature_cards_info_card);
    setOverlayCards(chikooPulpData.overlay_card);
    setWhyChooseSection(chikooPulpData.why_choose_section);
  }, []);

  return (
    <div className="chikoo-pulp-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#FF6B35] to-[#e85a2b] pt-28 md:pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            {heroSection.title}
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed">
            {heroSection.description}
          </p>
          <div className="mt-8 flex justify-center">
            <div className="bg-white/20 backdrop-blur-sm rounded-full px-6 py-3">
              <span className="text-white font-semibold">100% Natural • No Preservatives • Export Quality</span>
            </div>
          </div>
        </div>
      </section>

      <section className="catalog-section bg-white">
        <ProductVariations 
          product={mainProduct}
          variations={products}
        />
      </section>


      <section className="feature-text-section justify-center text-[#2c3e50]">
        <FeatureTextSection
          title={feature_text_section.title}
          subline={feature_text_section.subline}
          description={feature_text_section.description}
          className={"bg-gray-100 py-20"}
        />
      </section>

      <section className="features-card-info-section bg-gray-100 text-[#2c3e50]">
        <div className="max-w-[1440px] mx-auto px-6">
          <Row gutter={16} className="flex flex-wrap justify-center">
            {featureCardsInfo.map((feature, idx) => (
              <Col xs={24} sm={12} md={8} lg={8} key={idx} className="gap-4">
                <FeatureCard feature={feature} customClassName="bg-white" />
              </Col>
            ))}
          </Row>
          <div className="text-center pb-12 w-1/2 w-max-1/2 mx-auto">
            <p className="text-center text-2xl md:text-3xl pt-12">
              Available in various grades and pack sizes to meet your specific requirements.
            </p>
          </div>
        </div>
      </section>

      <section className="why-choose-section bg-gray-100 text-[#2c3e50]">
        <FeatureTextSection
          title={why_choose_section.title}
          description={why_choose_section.description}
        />

        <div className="max-w-[1440px] mx-auto px-6">
          <Row gutter={16} className="w-full p-2">
            {OverlayCards.map((card, idx) => (
              <Col xs={24} sm={24} md={12} lg={6} key={idx}>
                <OverlayCard
                  title={card.title}
                  subtitle={card.description}
                  image={`/media/${card.image}`}
                />
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </div>
  );
};

export default ChikooPulpPage;
